<template>
  <v-layout row align-center justify-center>
    <v-flex xs4 md4 pl-4>
      <v-switch
        v-model="useExistingUser"
        label=" Use Existing User"
        color="primary"
        :disabled="disabled"
      ></v-switch>
    </v-flex>
    <v-flex xs8 md8>
      <v-container>
        <v-autocomplete
          :error-messages="errorForField()"
          v-model="user"
          :items="users"
          :loading="loading"
          :search-input.sync="search"
          item-text="name"
          label="User"
          placeholder="Search by name, number or email"
          hide-no-data
          hide-selected
          no-filter
          return-object
          :disabled="!useExistingUser"
          @input="handleSelected"
        ></v-autocomplete>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "existing_user",
  model: {
    prop: "useExistingUser",
    event: "input"
  },
  props: {
    errors: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    useExistingUser: false
  },
  data: function() {
    return {
      user: {},
      loading: false,
      users: [],
      search: null
    };
  },
  methods: {
    handleSelected: function() {
      this.$emit("selectedUser", this.user);
    },
    errorForField: function() {
      try {
        return this.errors["use_existing"];
      } catch (err) {
        return null;
      }
    },
    resetError: function() {
      try {
        if (this.errors["use_existing"] != "") {
          this.errors["use_existing"] = "";
        }
      } catch (err) {}
    }
  },
  watch: {
    search(query) {
      this.resetError();

      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/customer/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          self.users = res.data.customers;
          self.loading = false;
        })
        .catch(function(err) {
          console.error(err);
          self.loading = false;
        });
    },
    useExistingUser() {
      if (this.useExistingUser == false) {
        // this.user = {};
      }
      this.$emit("useExistingUserToggled", this.useExistingUser);
    }
  }
};
</script>